<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">
            {{ __('Rendelések') }}
        </h1>

        <nav class="flex mb-8" v-if="sessionStore.user.role === 'admin'">
            <span class="bg-highlight border border-slate-200 cursor-pointer flex flex-col items-center justify-center md:flex-row -mr-px p-2 rounded-bl rounded-tl text-center text-sm text-white">
                <c-icon class="h-6 md:mr-2 stroke-white w-6" icon="columns" />
                Táblázatos nézet
            </span>
            <router-link class="bg-white border border-slate-200 cursor-pointer flex flex-col items-center justify-center md:flex-row -mr-px p-2 text-center text-slate-800 text-sm"
                         v-bind:to="{ name : 'orders.daily' }"
            >
                <c-icon class="h-6 md:mr-2 stroke-slate-800 w-6" icon="users" />
                Napi bontás
            </router-link>
            <router-link class="bg-white border border-slate-200 cursor-pointer flex flex-col items-center justify-center md:flex-row -mr-px p-2 text-center text-slate-800 text-sm"
                         v-bind:to="{ name : 'orders.byuser' }"
            >
                <c-icon class="h-6 md:mr-2 stroke-slate-800 w-6" icon="user" />
                Megrendelő szerint
            </router-link>
            <router-link class="bg-white border border-slate-200 cursor-pointer flex flex-col items-center justify-center md:flex-row p-2 rounded-br rounded-tr text-center text-slate-800 text-sm"
                         v-bind:to="{ name : 'orders.byproduct' }"
            >
                <c-icon class="h-6 md:mr-2 stroke-slate-800 w-6" icon="clipboard" />
                Termék összesítő
            </router-link>
        </nav>

        <div class="flex items-center mb-8">
            <c-control-text class="w-full" class-field="!h-10 !text-lg" class-group="bg-white border pl-2 rounded-none"
                            icon="search"
                            name="search"
                            v-bind:placeholder="__('Megrendelő keresése...')"
                            v-model="s"
                            v-on:keyup="search"
            />

            <c-button class="bg-slate-800 ml-4 shrink-0 text-white"
                      router
                      v-bind:disabled="orders.length === 0"
                      v-on:click="exportXls"
            >
                <c-icon class="h-4 mr-2 stroke-white w-4" icon="download" />{{ __('Exportálás') }}
            </c-button>
        </div>

        <div class="flex flex-col lg:flex-row lg:items-center">
            <strong class="mr-4">Oszlopok:</strong>
            <div class="flex flex-col lg:flex-row lg:items-center">
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Telefonszám"
                                  name="showColumns.phone"
                                  v-model="showColumns.phone"
                />
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Email"
                                  name="showColumns.email"
                                  v-model="showColumns.email"
                />
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Feketelistás?"
                                  name="showColumns.is_blacklisted"
                                  v-model="showColumns.is_blacklisted"
                />
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Kiszállítási idő"
                                  name="showColumns.delivery_time"
                                  v-model="showColumns.delivery_time"
                />
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Termék darabszám"
                                  name="showColumns.total"
                                  v-model="showColumns.total"
                />
                <c-control-toggle class="flex flex-row-reverse justify-end lg:flex-row lg:mr-6 lg:mt-0 mt-2"
                                  class-label="lg:ml-0 lg:mr-2 ml-2 mt-1"
                                  label="Fizetendő"
                                  name="showColumns.amount_due"
                                  v-model="showColumns.amount_due"
                />
            </div>
        </div>

        <div class="flex flex-col lg:flex-row lg:items-center mt-8">
            <strong class="mr-4">Szűrés:</strong>
            <div class="flex flex-col lg:flex-row lg:items-center">
                <span class="cursor-pointer mr-4 text-sm"
                      v-bind:class="{ 'text-highlight underline' : filters.userRole === 'all' }"
                      v-on:click="filters.userRole = 'all'; updateColumns(); updateProductTotals();"
                >
                    Összes
                </span>
                <span class="cursor-pointer mr-4 text-sm"
                      v-bind:class="{ 'text-highlight underline' : filters.userRole === 'user' }"
                      v-on:click="filters.userRole = 'user'; updateColumns(); updateProductTotals();"
                >
                    Felhasználók
                </span>
                <span class="cursor-pointer mr-4 text-sm"
                      v-bind:class="{ 'text-highlight underline' : filters.userRole === 'reseller' }"
                      v-on:click="filters.userRole = 'reseller'; updateColumns(); updateProductTotals();"
                >
                    Viszonteladók
                </span>
            </div>
        </div>

        <div class="bg-highlight flex items-center justify-between mb-10 mt-8 px-2 py-4 sticky text-white top-[var(--banner-offset)] z-30">
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-on:click="prevDay"
            >
                <c-icon class="h-6 mr-2 stroke-white w-6" icon="chevron-left" />
                <span class="hidden md:inline">{{ __('Előző') }}</span>
            </a>
            <span class="font-serif text-3xl text-center">
                {{ DateTime.fromISO(currentDate).toFormat(localizationStore.dateFormat) }}
                <small class="capitalize font-sans text-base">
                    ({{ DateTime.fromISO(currentDate).setLocale(localizationStore.locale).toFormat('cccc') }})
                </small>
            </span>
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-on:click="nextDay"
            >
                <span class="hidden md:inline">{{ __('Következő') }}</span>
                <c-icon class="h-6 ml-2 stroke-white w-6" icon="chevron-right" />
            </a>
        </div>

        <div class="flex sticky top-[calc(4rem+var(--banner-offset))] z-20"
             v-if="orders.length > 0 && products.length > 0"
        >
            <div class="bg-slate-100 border border-b-4 border-black font-bold md:w-80 p-2 shrink-0 text-left text-sm w-52">
                Vevő<br /><br />
            </div>
            <div class="overflow-hidden"
                 ref="stickyHeaderRef"
            >
                <table>
                    <thead>
                        <tr>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.phone">Telefonszám</th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.email">Email</th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.is_blacklisted">Feketelistás?</th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.delivery_time">Kiszállítási<br />időpont</th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.total">Termék darabszám</th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap" v-if="showColumns.amount_due">Fizetendő</th>
                            <template v-for="product in visibleProducts">
                                <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap">
                                    {{ product.abbreviation ?? product.name }}<br />
                                    {{ product.totalOrdered - product.completedOrders }} / {{ product.totalOrdered }}
                                </th>
                            </template>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>

        <div class="relative"
             v-if="orders.length > 0 && products.length > 0"
        >
            <div class="md:pl-80 pl-52 overflow-x-scroll overflow-y-visible"
                 ref="scrollContainerRef"
                 v-on:scroll="syncStickyHeader"
            >
                <table>
                    <thead class="hidden">
                        <tr>
                            <th class="absolute bg-slate-100 border border-b-4 border-black left-0 md:w-80 p-2 text-left text-sm top-0 w-52 z-10">
                                Vevő<br /><br />
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.phone"
                            >
                                Telefonszám
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.email"
                            >
                                Email
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.is_blacklisted"
                            >
                                Feketelistás?
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.delivery_time"
                            >
                                Kiszállítási<br />időpont
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.total"
                            >
                                Termék darabszám
                            </th>
                            <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                v-if="showColumns.amount_due"
                            >
                                Fizetendő
                            </th>
                            <template v-for="product in visibleProducts">
                                <th class="bg-slate-100 border border-b-4 border-black p-2 text-center text-sm whitespace-nowrap"
                                >
                                    {{ product.abbreviation ?? product.name }}<br />
                                    {{ product.totalOrdered - product.completedOrders }} / {{ product.totalOrdered }}
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="order in orders">
                            <tr v-show="filters.userRole === 'all' || (filters.userRole === 'reseller' && order.user.role === 'reseller') || (filters.userRole === 'user' && order.user.role !== 'reseller')">
                                <td class="absolute bg-slate-50 border-t h-24 left-0 md:w-80 p-2 text-sm w-52">
                                    <div class="flex items-center">
                                        <c-control-toggle class="mr-4" name="completed"
                                                          v-model="order.items_by_day[currentDay][0].is_completed"
                                                          v-on:update:model-value="markCompleted(order.id, currentDay)"
                                        />

                                        <span v-bind:class="{ 'line-through' : order.items_by_day[currentDay][0].is_completed }">
                                            <span class="uppercase">{{  order.user.lastname }}</span>
                                            {{  order.user.firstname }}
                                        </span>
                                    </div>

                                    <c-control-text class="mt-4" class-field="!bg-slate-800 !text-white"
                                                    name="notes"
                                                    placeholder="Megjegyzés"
                                                    v-bind:model-value="order.notes_by_day?.[currentDay] ?? ''"
                                                    v-on:update:model-value="updateNotes(order, currentDay, $event)"
                                    />
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.phone"
                                >
                                    {{ order.user.phone }}
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.email"
                                >
                                    {{ order.user.email }}
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.is_blacklisted"
                                >
                                    <c-icon class="h-6 mx-auto stroke-error w-6" icon="check-circle"
                                            v-if="order.user.is_blacklisted"
                                    />
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.delivery_time"
                                >
                                    <span v-if="order.user.role === 'reseller' && order.items_by_day[currentDay][0].delivery_time">
                                        {{ order.items_by_day[currentDay][0].delivery_time.substr(0,2) + ':' + order.items_by_day[currentDay][0].delivery_time.substr(2) }}
                                    </span>
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.total"
                                >
                                    {{ order.items_by_day[currentDay].total }}
                                </td>
                                <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                    v-if="showColumns.amount_due"
                                >
                                    <span v-if="order.ipn_status === 'FINISHED'">{{ currencyStore.format(0, 'huf') }}</span>
                                    <span>{{ currencyStore.format(order.items_by_day[currentDay].amount, 'huf') }}</span>
                                </td>
                                <template v-for="(product, productIndex) in visibleProducts">
                                    <td class="border-t h-24 p-2 text-center text-sm whitespace-nowrap"
                                        v-bind:class="{ 'bg-slate-100': productIndex % 2 !== 1 }"
                                    >
                                        <template v-for="item in order.items_by_day[currentDay]">
                                            <span v-if="item.product_id === product.id">
                                                {{ item.quantity }}
                                            </span>
                                        </template>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <span class="block font-serif text-center text-2xl" v-else-if="loading">{{ __('Betöltés alatt') }}</span>
        <span class="block font-serif text-center text-2xl" v-else>{{ __('Nincs találat') }}</span>
    </div>
</template>

<script setup lang="ts">
    import { computed, inject, nextTick, onMounted, ref, watch } from 'vue';
    import {
        CButton,
        CIcon,
        CControlToggle,
        CControlText,
    } from '@teamfurther/cinderblock';
    import { DateTime } from 'luxon';
    import debounce from 'debounce';
    import OrderRepository from '../../repositories/OrderRepository';
    import ProductRepository from '../../repositories/ProductRepository';
    import { useCurrencyStore } from '../../stores/currency';
    import { useLocalizationStore } from '../../stores/localization';
    import { useRequestStore } from '../../stores/request';
    import { useSessionStore } from '../../stores/session';

    const __ = inject('__');
    const currencyStore = useCurrencyStore();
    const currentDate = ref(DateTime.now().setLocale('en'));
    const currentDay = computed(() => currentDate.value.weekdayLong.toLowerCase());
    const filters = ref({
        userRole: 'all',
    });
    const loading = ref(0);
    const localizationStore = useLocalizationStore();
    const orderRepository = new OrderRepository();
    const orders = ref([]);
    const productRepository = new ProductRepository();
    const products = ref([]);
    const requestStore = useRequestStore();
    const sessionStore = useSessionStore();
    const s = ref<string>('');
    const showColumns = ref({
        amount_due: true,
        delivery_time: true,
        email: true,
        is_blacklisted: true,
        phone: true,
        total: true,
    });
    const scrollContainerRef = ref<HTMLElement | null>(null);
    const sort = ref<string>('created_at');
    const stickyHeaderRef = ref<HTMLElement | null>(null);
    const visibleProducts = computed(() => products.value.filter(p => p.totalOrdered > 0));

    function syncColumnWidths() {
        nextTick(() => {
            if (!scrollContainerRef.value || !stickyHeaderRef.value) return;
            const firstRow = scrollContainerRef.value.querySelector<HTMLElement>(
                'tbody tr:not([style*="display: none"])'
            );
            if (!firstRow) return;
            const tds = Array.from(firstRow.querySelectorAll<HTMLElement>('td'));
            const ths = Array.from(stickyHeaderRef.value.querySelectorAll<HTMLElement>('th'));
            // Measure all widths first to avoid reflow mid-loop
            const widths = ths.map((th, i) => Math.max(th.offsetWidth, tds[i + 1]?.offsetWidth ?? 0));
            ths.forEach((th, i) => { th.style.minWidth = widths[i] + 'px'; });
            tds.slice(1).forEach((td, i) => { if (widths[i] != null) td.style.minWidth = widths[i] + 'px'; });
        });
    }

    function syncStickyHeader(e: Event) {
        if (stickyHeaderRef.value) stickyHeaderRef.value.scrollLeft = (e.target as HTMLElement).scrollLeft;
    }

    async function exportXls() {
        requestStore.post('orders/export/table', {
            columns: showColumns.value,
            date: currentDate.value.toFormat('yyyy-MM-dd'),
            filters: filters.value,
        }).then((response : any) => {
            const blob = new Blob([
                new Uint8Array([0xEF, 0xBB, 0xBF]), // UTF-8 BOM
                response.data
            ]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;

            a.download = 'tablazat_'+ currentDate.value.toFormat('yyyy-MM-dd') +'.csv';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    async function getOrders() {
        loading.value++;

        orders.value = await orderRepository.index({
            filters: {
                day: currentDate.value.weekdayLong.toLowerCase(),
                week: currentDate.value.year + '.' + currentDate.value.weekNumber,
                user: s.value,
            },
            include: ['items', 'user', 'user.group'],
            sort: sort.value,
        });

        updateProductTotals();

        loading.value--;
    }

    async function getProducts() {
        loading.value++;

        products.value = await productRepository.index();

        loading.value--;
    }

    async function markCompleted(orderId, day) {
        requestStore.put('orders/mark-completed', {
            order_id: orderId,
            day: day,
        })
        .then((response : any) => {
            getOrders();
        }).catch(error => reject(error));
    }

    async function nextDay() {
        currentDate.value = currentDate.value.plus({ days: 1 });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        }

        await getOrders();
    }

    async function prevDay() {
        currentDate.value = currentDate.value.minus({ days: 1 });

        if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.minus({ day: 2 });
        }

        await getOrders();
    }

    // Notes are stored per delivery day, since one order covers a whole week.
    // One debouncer per order + day, so switching rows/days doesn't drop a pending save.
    const noteSavers = new Map();

    function updateNotes(order, day, notes) {
        order.notes_by_day = { ...(order.notes_by_day ?? {}), [day]: notes };

        const key = order.id + ':' + day;
        if (!noteSavers.has(key)) {
            noteSavers.set(key, debounce((value) => orderRepository.update(order.id, { day, notes: value }), 500));
        }
        noteSavers.get(key)(notes);
    }

    function updateColumns() {
        switch (filters.value.userRole) {
            case 'reseller':
                showColumns.value = {
                    amount_due: true,
                    delivery_time: true,
                    email: false,
                    is_blacklisted: false,
                    phone: false,
                    total: true,
                }

                break;
            case 'user':
                showColumns.value = {
                    amount_due: true,
                    delivery_time: false,
                    email: true,
                    is_blacklisted: true,
                    phone: true,
                    total: true,
                }

                break;
            default:
                showColumns.value = {
                    amount_due: true,
                    delivery_time: true,
                    email: true,
                    is_blacklisted: true,
                    phone: true,
                    total: true,
                }

                break;
        }
    }

    function updateProductTotals() {
        products.value.forEach((product) => {
            product.completedOrders = 0;
            product.totalOrdered = 0;

            orders.value.forEach((order) => {
                if (
                    (order.user.role === 'reseller' && filters.value.userRole === 'user')
                    || (order.user.role !== 'reseller' && filters.value.userRole === 'reseller')
                ) {
                    return;
                }

                order.items_by_day[currentDay.value].forEach((item) => {
                    if (item.product_id === product.id) {
                        product.totalOrdered += item.quantity;

                        if (item.is_completed) {
                            product.completedOrders += item.quantity;
                        }
                    }
                });
            });
        });

        orders.value.forEach((order) => {
            order.items_by_day[currentDay.value].amount = 0;
            order.items_by_day[currentDay.value].total = 0;
            order.items_by_day[currentDay.value].forEach((item) => {
                order.items_by_day[currentDay.value].amount += item.price_gross * item.quantity;
                order.items_by_day[currentDay.value].total += item.quantity;
            });
        });
    }

    const search = debounce(async () => {
        await getOrders();
    }, 500);

    watch(orders, syncColumnWidths);
    watch(filters, syncColumnWidths, { deep: true });
    watch(showColumns, syncColumnWidths, { deep: true });

    onMounted(async () => {
        await getProducts();
        await getOrders();
        syncColumnWidths();
    });
</script>
